import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PDFService } from '../../services/pdf.service';

export interface DialogData {
  PDFTemplate: string;
  data: any;
}

@Component({
  selector: 'app-pdf-generate',
  templateUrl: './pdf-generate.component.html',
  styleUrls: ['./pdf-generate.component.scss']
})
export class PdfGenerateComponent {
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private pdfService: PDFService) { }

}
